import { Service } from "@toeverything/infra";
import type { WorkspaceService } from "../../workspace";
import { WorkspaceTeams } from "../entities/teams";
import type { WorkspaceTeamsStore } from "../stores/teams";
import { MyTeamIds } from "../entities/my-team-ids";

export class WorkspaceTeamService extends Service {

  constructor(
    private readonly store: WorkspaceTeamsStore,
    private readonly workspaceService: WorkspaceService
  ) {
    super();
  }

  teams = this.framework.createEntity(WorkspaceTeams);
  myTeamIds = this.framework.createEntity(MyTeamIds);

  async createTeam(name: string, parentId?: string | null) {
    return await this.store.createTeam(
      this.workspaceService.workspace.id,
      name,
      parentId
    );
  }

  async updateTeam(id: string, name: string) {
    return await this.store.updateTeam(id, name);
  }

  async deleteTeam(id: string) {
    return await this.store.deleteTeam(id);
  }

  async addTeamMembers(teamId: string, memberIds: string[]) {
    return await this.store.addTeamMembers(teamId, memberIds);
  }

  async removeTeamMember(teamId: string, memberId: string) {
    return await this.store.removeTeamMember(teamId, memberId);
  }
  
  async syncTeam() {
    return await this.store.syncTeam(this.workspaceService.workspace.id);
  }

  async loadTeamOrUser(input: {
    id: string;
    type: 'user' | 'team';
  }[]) {
    return await this.store.loadTeamOrUser(input);
  }

}